
import React, { createContext, useContext, ReactNode } from 'react';
import { usePageLoading } from '@/hooks/use-page-loading';

interface LoadingContextType {
  isLoading: boolean;
  startLoading: () => void;
  stopLoading: () => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

interface LoadingProviderProps {
  children: ReactNode;
  minDuration?: number;
  timeout?: number;
}

export const LoadingProvider: React.FC<LoadingProviderProps> = ({ 
  children, 
  minDuration = 500,
  timeout = 5000 
}) => {
  const loadingState = usePageLoading({ minDuration, timeout });

  return (
    <LoadingContext.Provider value={loadingState}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoadingContext = (): LoadingContextType => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoadingContext must be used within a LoadingProvider');
  }
  return context;
};
